module.exports = __webpack_public_path__ + "static/media/feature2.b1d13441.png";